import { render, staticRenderFns } from "./newsVue.vue?vue&type=template&id=b0cd279c&scoped=true&"
import script from "./newsVue.vue?vue&type=script&lang=js&"
export * from "./newsVue.vue?vue&type=script&lang=js&"
import style0 from "./newsVue.vue?vue&type=style&index=0&id=b0cd279c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cd279c",
  null
  
)

export default component.exports